export const getBaseURL = () => {
  console.log("REACT_APP_BASE_URL = " + process.env.REACT_APP_BASE_URL);
  const inDevEnvironment = process.env.NODE_ENV === "development";

  console.log("getBaseURL: inDevEnvironment = ", inDevEnvironment);
  return process.env.REACT_APP_BASE_URL;
};
